// Připomínka herního světa při zadávání slova (21. 10. 2026).
//
// Svět posouvá hodnocení VŠECH tipů kola, a zadavatel to nevěděl: „škrabadlo"
// ve světě Harry Potter si model vyložil jako kouzelného tvora a „živočich"
// vyšel na 84 °C (hlášení Premium hráčky, skupina prdelky🤍). Stejně dřív
// „čočka" ve světě DC Comics. Zadavatel to má vědět dřív, než slovo pošle.
//
// Fialový pill „Svět: …" jako ve formuláři herního světa (tema-group-pill) a
// vedle něj stejně vysoké „i": vysvětlení v bublině na kliknutí, ať okno zůstane
// krátké a kdo to zná, nemusí to číst pokaždé.

import { useEffect, useRef, useState } from "react";

export default function TemaReminder({ tema, t }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const zavrit = (e) => {
      if (e.type === "keydown" ? e.key === "Escape" : !ref.current?.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", zavrit);
    document.addEventListener("keydown", zavrit);
    return () => {
      document.removeEventListener("mousedown", zavrit);
      document.removeEventListener("keydown", zavrit);
    };
  }, [open]);

  if (!tema) return null;
  return (
    <div className="social-modal__tema" ref={ref}>
      <div className="social-modal__tema-row">
        <p className="tema-group-pill" title={tema}>{t("groups.temaRoundPill", { name: tema })}</p>
        <button
          type="button"
          className="tema-info-btn"
          aria-label={t("groupWord.temaInfoLabel")}
          aria-expanded={open}
          onClick={() => setOpen((o) => !o)}
        >
          i
        </button>
      </div>
      {open && (
        <p className="tema-info-bubble" role="tooltip">
          {t("groupWord.temaReminder")}
        </p>
      )}
    </div>
  );
}
